import { LeastRecentlyUsedCache } from 'lib/least-recently-used-cache'
import { AccessReviewViewType } from 'pbts/c1/api/accessreview/v1/accessreview'

const AccessReviewStyleLocalStorageCacheKey = 'access_review_style_cache'
const AccessReviewStyleLocalStorageCacheMaxSize = 100

export const getAccessReviewStyleSelection = (accessReviewID: string | undefined): AccessReviewViewType => {
    if (!accessReviewID) {
        return AccessReviewViewType.UNSPECIFIED
    }
    const cacheJSON = localStorage.getItem(AccessReviewStyleLocalStorageCacheKey)
    const lru = new LeastRecentlyUsedCache<AccessReviewViewType>(AccessReviewStyleLocalStorageCacheMaxSize, cacheJSON)
    return lru.get(accessReviewID) || AccessReviewViewType.UNSPECIFIED
}

export const getReviewStyleFromStorageOrDefault = (accessReviewID: string | undefined, defaultView: AccessReviewViewType | undefined):
    AccessReviewViewType => {
    const reviewStyle = getAccessReviewStyleSelection(accessReviewID)

    if (reviewStyle !== AccessReviewViewType.UNSPECIFIED) {
        return reviewStyle
    }
    if (defaultView) {
        setAccessReviewStyleSelection(accessReviewID, defaultView)
        return defaultView
    }
    return AccessReviewViewType.UNSPECIFIED
}

export const setAccessReviewStyleSelection = (accessReviewID: string | undefined, reviewStyle: AccessReviewViewType): void => {
    if (!accessReviewID || reviewStyle === AccessReviewViewType.UNSPECIFIED) {
        return
    }

    const cacheJSON = localStorage.getItem(AccessReviewStyleLocalStorageCacheKey)
    const lru = new LeastRecentlyUsedCache<AccessReviewViewType>(AccessReviewStyleLocalStorageCacheMaxSize, cacheJSON)
    lru.set(accessReviewID, reviewStyle)
    localStorage.setItem(AccessReviewStyleLocalStorageCacheKey, lru.toJSON())
}
